export const APP_CONFIG = {
  system_type: 'order',
  // baseDomain: 'http://127.0.0.1:8300',
  // baseDomainDeposit: 'http://127.0.0.1:8300',
  baseDomain: 'https://clapi.songphuongtrade.vn',
  baseDomainDeposit: 'https://clapi.songphuongtrade.vn',
  // baseDomain: 'https://clapi-test.songphuongtrade.vn',
  // baseDomainDeposit: 'https://clapi-test.songphuongtrade.vn',
  authSetting: {
    tokenName: 'token',
  },
  settings: {
    main_domain: 'https://songphuongtrade.vn',
    main_domain_deposit: 'https://songphuongtrade.vn',
    firebase_storage: 'https://firebasestorage.googleapis.com/v0/b/songphuongtrade.firebasestorage.app/o'
  },
  eventBusAction: {
    disableMenuLeft: 'disableMenuLeft',
    disableHeader: 'disableHeader',
    showHideMenuLeft: 'showHideMenuLeft',
    reloadWithdrawalHistories: 'reloadWithdrawalHistories',
    reloadNotification: 'reloadNotification'
  },
  stateKey: {
    authStore: 'authStore',
    commonStore: 'commonStore',
    cartState: 'cartState',
  },
  sqlDateFormat: 'YYYY-MM-DD hh:mm:ss',
  notifyRefreshTime: 5
};
